<template>
    <portal-mobile portal-to="mobile-b2b-select">
        <div :class="{'price-switch--inactive': !isActive, 'd-none': noSwitchCountry}">
            <a id="js--price-switch"
               data-toggle="dropdown"
               href="#"
               aria-expanded="false"
               aria-haspopup="true"
               data-boundary="viewport">
                <!-- display privat customer when country has no vat switch like CH -->
                {{ priceType.active }}
                <svg v-if="isActive" xmlns="http://www.w3.org/2000/svg">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-caret"></use>
                </svg>
            </a>
            <div v-if="isActive"
                 class="dropdown-menu header__dropdown"
                 aria-labelledby="js--price-switch">
                <ul class="list-unstyled">
                    <li>
                        <a href="#" @click="toggleType($event, priceType.inactive.type)">
                            {{ priceType.inactive.label }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </portal-mobile>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import TranslationService from 'ceres/app/services/TranslationService';
import {setPriceTypeMapCookie} from '~/app/helper/Cookie';

export default {

    computed: {
        ...mapState({
            currentPriceType: state => state.localization.currentPriceType,
            noSwitchCountry: state => state.localization.noSwitchCountry,
            guestMail: state => state.localization.guestMail
        }),
        ...mapGetters([
            'isLoggedIn'
        ]),
        isActive() {
            // if customer is logged in show prices for customer
            // if current shipping country has not vat hide the switch
            return !this.isLoggedIn && this.guestMail === '';
        },
        priceType() {
            return {
                active   : this.getLabel('b2c'),
                inactive : {
                    label : this.getLabel('b2b'),
                    type  : this.currentPriceType === 'b2c' ? 'b2b' : 'b2c'
                }
            }
        }
    },

    methods: {
        toggleType($event, type) {

            $event.preventDefault();

            setPriceTypeMapCookie(App.language, type);

            window.location.reload();

        },
        getLabel(type) {

            let suffix = !this.isActive ? 'LoggedIn' : '';

            return this.currentPriceType === type ?
                TranslationService.translate('OD3dprimaV2::Template.b2cCustomer'+suffix) :
                TranslationService.translate('OD3dprimaV2::Template.b2bCustomer'+suffix)
        }
    }
}
</script>
